'use strict';

angular.module('magview')
  .controller('AttendanceTrackingCtrl', [
    '$scope', 'AttendanceTrackingViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.selectedUserId);
    }
  ]);
